export default __webpack_public_path__ + "static/media/ds.0d6aded0.svg";